export const ADMIN_INSPECTION_LIST_INIT = "ADMIN_INSPECTION_LIST_INIT";
export const ADMIN_INSPECTION_FILTERS_APPLY = "ADMIN_INSPECTION_FILTERS_APPLY";

//  ******* Inspection List GET *******

export const ADMIN_INSPECTION_LIST_FETCH_BEGIN = "ADMIN_INSPECTION_LIST_FETCH_BEGIN";
export const ADMIN_INSPECTION_LIST_FETCH_SUCCESS = "ADMIN_INSPECTION_LIST_FETCH_SUCCESS";
export const ADMIN_INSPECTION_LIST_FETCH_FAIL = "ADMIN_INSPECTION_LIST_FETCH_FAIL";

//
// Inspection Job Search
//

export const ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_BEGIN = "ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_BEGIN";
export const ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_SUCCESS = "ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_SUCCESS";
export const ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_FAIL = "ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_FAIL";

export const ADMIN_INSPECTION_LIST_RESET = "ADMIN_INSPECTION_LIST_RESET";

export const ADMIN_INSPECTION_FILTERS_RESET = "ADMIN_INSPECTION_FILTERS_RESET";
